var map = {
	"./bg.json": "dcd0",
	"./cz.json": "d6f6",
	"./de.json": "6ce2",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fr.json": "f693",
	"./hr.json": "92d7",
	"./hu.json": "4e73",
	"./it.json": "0825",
	"./pl.json": "89b2",
	"./ro.json": "9542",
	"./sk.json": "3da9",
	"./sl.json": "d34a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";